import DefaultLayout from "components/layout/DefaultLayout";
import { useGetCallCenterAgents } from "../../../services/agents.service";
import { useAccountChange } from "../../../hooks/useAccountChange";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import CallCenterStats from "./CallCenterStats";
import AgentsDepartmentsList from "./AgentsDepartmentsList";
import ActiveCallsList from "./ActiveCallsList";
import QueuedCallsList from "./QueuedCallsList";
import { MockAgent, MockDepartment, ActiveCall, QueuedCall } from "./types";
import "./callCenter.scss";
import useCallCenterSocket from "hooks/useCallCenterSocket";


const CallCenterDefault = () => {
  useCallCenterSocket();
  const dispatch = useAppDispatch();
  const { refetch: refetchAgents } = useGetCallCenterAgents();
  useAccountChange(true, refetchAgents);
  // Initialization of Call Center data now handled via WebSocket in useCallCenterSocket
  const activeCallsRaw = useAppSelector((state) => state.callCenter.activeCalls);
  const queueCallsRaw = useAppSelector((state) => state.callCenter.queueCalls);

  return (
    <DefaultLayout>
      <div className="call-center-container">
        <div className="call-center-body-container">
          <div className="call-center-mini-cards-container">
            <CallCenterStats />
          </div>

          <AgentsDepartmentsList
          />

          <div className="active-queued-calls-container">
            <ActiveCallsList activeCalls={activeCallsRaw} />
            <QueuedCallsList />
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
};

export default CallCenterDefault;
